async function isLocalhost() {
    const url = window.location.href;

    const locals = [
        "localhost",
        "127.0.0.1",
    ];

    return locals.some((local) => url.includes(local));
}

async function getBaseURL() {
    const isLocal = await isLocalhost();

    if (isLocal) {
        const url = process.env.VUE_APP_API_URL || "http://localhost";
        const port = process.env.VUE_APP_API_PORT || "8000";

        return `${url}:${port}`;
    } else {
        return process.env.VUE_APP_PRODUCTION_URL || "https://api.resortecobusiness.com.br";
    }
}

export { isLocalhost, getBaseURL };